import { combineReducers } from 'redux';
import auth from './auth';
import adminAuth from './adminAuth';
import user from './users';
import cat from "./categories";
import profile from './profile';
import quote from './quote';
import demand from './demand_services';
import notifications from './notification';
import chat from './chat';

export default combineReducers({
  auth,
  adminAuth,
  user,
  profile,
  cat,
  quote,
  demand,
  notifications,
  chat
});